<template>
<div class="switch">
  <input type="checkbox" class="switch__check" v-model="consentValue" :id="elementId()">
  <label class="switch__label" :for="elementId()">
      <span class="switch__track"></span>
      <span class="switch__bobble"></span>
  </label>
</div>
</template>

<script lang='ts'>
import {
  Component,
  Prop,
  Vue,
  Watch
} from 'vue-property-decorator';

@Component
export default class ToggleSwitchComponent extends Vue {
  @Prop({ default: null })
  public consentItem!: string;

  @Prop({ default: false })
  public optinAll!: boolean;

  @Prop({ default: null })
  public elementIdPrefix!: string;

  public consentValue: boolean = false;

  @Watch('optinAll')
  public optinAllChanged() {
    this.consentValue = this.optinAll;
  }

  @Watch('consentValue')
  public toggleState() {
    this.$emit('updateToggle', this.consentValue);
  }

  public elementId() {
    return `${this.elementIdPrefix}-${this.consentItem}`;
  }
}
</script>
